var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-content',[_c('h1',{staticClass:"text-center primary--text"},[_vm._v("Reports")])]),_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"8"}},[_c('Reports')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }